var shapeLoaderCache = {};
var currentShapesArray = [];

function initShapeTable() {
    getNorthAmericanSteelShapes('AISC/W-shapes.json');
}

function isSteelShape(shapeData) {
    return ('AISC_Manual_Label' in shapeData || 'Profile' in shapeData || shapeData['Type'] === 'Dayton Superior Soldier');
}

function isWoodShape(shapeData) {
    return ('Type' in shapeData && shapeData['Type'] === 'Lumber');
}

function isEngineeredLumber(shapeData) {
    return ('Grade' in shapeData);
}

function shapeName(shapeData) {
    if('AISC_Manual_Label' in shapeData) {
        return shapeData['AISC_Manual_Label'];
    }
    if('Profile' in shapeData) {
        return shapeData['Profile'];
    }
    if('Grade' in shapeData) {
        return shapeData['Type'] + " " + shapeData['Grade'];
    }
    return shapeData['Name'];
}

function hasFlanges(shapeData) {
    var type = shapeData['Type'];
    return (type === "W" || type === "M" || type === "S" || type === "HP");
}

function hasTopFlange(shapeData) {
    var type = shapeData['Type'];
    return (type === "WT" || type === "MT" || type === "ST");
}

function hasBottomFlange(shapeData) {
    var type = shapeData['Type'];
    return (type === "L");
}

function isIShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "W" || type === "M" || type === "S" || type === "HP");
}

function isTShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "WT" || type === "MT" || type === "ST");
}

function isLShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "L");
}

function isCShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "C" || type === "MC");
}

function isHssRectangleShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "HSS Rectangle");
}

function isHssSquareShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "HSS Square");
}

function isHssRoundShape(shapeData) {
    var type = shapeData['Type'];
    return (type === "HSS Round");
}

function onPlySelectorChange() {
    // get currnent ply selection and set it in the active project
    var numberOfPlys = document.getElementById("ply-selector").selectedIndex + 1;
    activeProject.beamController.UpdateNumberOfPlys(numberOfPlys);
}

function setPlySelectorIndex() {
    document.getElementById("ply-selector").selectedIndex = activeProject.numberOfPlys - 1;
}

/**
* return the current shape - can be wood or steel
*
* @returns {Dictionary}
*/
function getCurrentSelectedShape() {
    var currentShape = activeProject.shape;
    if( !isSteelShape(currentShape) ) {
        var gamma = 0.25; //1.1 slugs/ft^3/12in/12in*32.2
        currentShape["W"] = Number(gamma * Number(currentShape["A"]));
    }

    return currentShape;
}

function openModalShapeDialog() {
    $('#modal-shape-selector-dialog').modal('show');
}

function loadNorthAmericanSteelShapesTable(data) {
    if (data.length <= 0) {
        return
    }

    document.getElementById('ply-selector-group').classList.add('hidden')
    document.getElementById('use-custom-shape-checkbox').classList.add('hidden')
    document.getElementById("shape-dialog-copywrite-info").innerHTML = ""

    currentShapesArray = data

    let str = "<table class='table'>"
    str += "<thead><tr><th>Name</th><th>Area</th><th>Weight (lbs/ft)</th>"
    str += "<th>Iz (in<sup>4</sup>)</th><th>Iy (in<sup>4</sup>)</th></tr>"
    str += "</thead>"

    for(var i = 0; i < data.length; i++) {
        str += "<tr class='wsShape_" + i + "'>";
        str += "<td>" + data[i]['AISC_Manual_Label'] + "</td>";
        str += "<td>" + data[i].A + "</td>";
        str += "<td>" + Number(data[i].W).toFixed(2) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Ix).toFixed(3).toString()) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Iy).toFixed(3).toString()) + "</td>";
    }
    str += "</table>";
    
    let table = document.getElementById('shape-table')
    table.innerHTML = str

    var rows = table.getElementsByTagName("tr")
    for (let i = 1; i < rows.length; i++) {
        var currentRow = rows[i]
        currentRow.onclick = function() {
            const customEvent = new CustomEvent('north-american-steel-shape-selected', { detail: currentShapesArray[i-1] })
            document.dispatchEvent(customEvent)
            $('#modal-shape-selector-dialog').modal('toggle');
        }
    }
}

function loadWoodShapesTable(data) {
    if (data.length <= 0) {
        return;
    }

    document.getElementById('ply-selector-group').classList.add('hidden');
    document.getElementById('use-custom-shape-checkbox').classList.add('hidden');
    document.getElementById("shape-dialog-copywrite-info").innerHTML = "";

    currentShapesArray = data;
    var str = '';

    str = "<table class='table'><thead>";
    str += "<tr>";
    str += "<th>Name</th>";
    str += "<th>Area</th>";
    str += "<th>Iz (in<sup>4</sup>)</th>";
    str += "<th>Iy (in<sup>4</sup>)</th></tr>";
    str += "</thead>";

    for(var i = 0; i < data.length; i++) {
        str += "<tr class='wsShape_" + i + "'>";
        str += "<td>" + data[i]['Name'] + "</td>";
        str += "<td>" + data[i].A + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Ix).toFixed(3).toString()) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Iy).toFixed(3).toString()) + "</td>";
    }
    str += "</table>";
    $("#shape-table").html(str);

    
    $('#shape-table tr').click(function (event) {
        var myClass = $(this).attr("class"),
            index = myClass.split(/wsShape_/)[1];
        $('#modal-shape-selector-dialog').trigger( "wood-shape-selected", currentShapesArray[index]);
        $(function () {
            $('#modal-shape-selector-dialog').modal('toggle');
        });
    });
}

function loadEngineeredLumberShapesTable(data) {
    if (data.length <= 0) {
        return;
    }

    document.getElementById('ply-selector-group').classList.remove('hidden');
    document.getElementById("ply-selector").selectedIndex = activeProject.numberOfPlys - 1;
    document.getElementById('use-custom-shape-checkbox').classList.add('hidden');
    document.getElementById("shape-dialog-copywrite-info").innerHTML = "TrusJoist, Microllam LVL, Parallam PSL and TimberStrand LSL are registered trademarks of Weyerhaeuser Company";


    currentShapesArray = data;

    var plys = parseInt(activeProject.numberOfPlys);

    var str = '';

    //"Grade", "Type", "Width", "Height", "w", "h", "Moment", "Shear", "Ixx", "W"

    str = "<table class='table'><thead>";
    str += "<tr>";
    str += "<th>Name</th>";
    str += "<th>Grade</th>";
    str += "<th>Width</th>";
    str += "<th>Height</th>";
    str += "<th>Moment (ft-lbs)</th>";
    str += "<th>Shear (lbs)</th>";
    str += "</thead>";

    for(var i = 0; i < data.length; i++) {
        str += "<tr class='wsShape_" + i + "'>";
        str += "<td>" + data[i]['Type'] + "</td>";
        str += "<td>" + data[i]['Grade'] + "</td>";
        str += "<td>" + data[i]['Width'] + "</td>";
        str += "<td>" + data[i]['Height'] + "</td>";
        str += "<td>" + parseFloat(data[i]['Moment']) * plys + "</td>";
        str += "<td>" + parseFloat(data[i]['Shear']) * plys + "</td>";
    }
    str += "</table>";
    $("#shape-table").html(str);

    
    $('#shape-table tr').click(function (event) {
        var myClass = $(this).attr("class"),
            index = myClass.split(/wsShape_/)[1];
        $('#modal-shape-selector-dialog').trigger( "engineered-lumber-shape-selected", currentShapesArray[index]);
        $(function () {
            $('#modal-shape-selector-dialog').modal('toggle');
        });
    });
}

function loadEuropeanSteelShapesTable(data) {
    if (data.length <= 0) {
        return;
    }

    document.getElementById('ply-selector-group').classList.add('hidden');
    document.getElementById('use-custom-shape-checkbox').classList.add('hidden');

    currentShapesArray = data;

    var str = '';

    str = "<table class='table'><thead>";
    str += "<tr>";
    str += "<th>Name</th>";
    str += "<th>Area mm<sup>2</sup></th>";
    str += "<th>Weight (kg/m)</th>";
    str += "<th>Iz (cm<sup>4</sup>)</th>";
    str += "<th>Iy (cm<sup>4</sup>)</th></tr>";
    //str += "<th>Sz (&#10005;10<sup>6</sup> mm<sup>3</sup>)</th>";
    //str += "<th>Sy (&#10005;10<sup>6</sup> mm<sup>3</sup>)</th></tr>";
    //str += "<th>Zz (&#10005;10<sup>6</sup> mm<sup>3</sup>)</th>";
    //str += "<th>Zy (&#10005;10<sup>6</sup> mm<sup>3</sup>)</th></tr>";
    str += "</thead>";

    for(let i = 0; i < data.length; i++) {
        str += "<tr class='wsShape_" + i + "'>";
        str += "<td>" + data[i]['Profile'] + "</td>";
        str += "<td>" + (parseFloat(data[i].A) * 1000 * 1000).toFixed(0) + "</td>";
        str += "<td>" + Number(data[i].W).toFixed(2) + "</td>";
        str += "<td>" + (parseFloat(Number(data[i].Ix) * Math.pow(100,4)).toFixed(2).toString()) + "</td>";
        str += "<td>" + (parseFloat(Number(data[i].Iy) * Math.pow(100,4)).toFixed(2).toString()) + "</td>";
        //str += "<td>" + parseFloat(Number(data[i].Sx).toFixed(3).toString()) + "</td>";
        //str += "<td>" + parseFloat(Number(data[i].Sy).toFixed(3).toString()) + "</td>";
        //str += "<td>" + parseFloat(Number(data[i].Zx).toFixed(3).toString()) + "</td>";
        //str += "<td>" + parseFloat(Number(data[i].Zy).toFixed(3).toString()) + "</td>";
    }
    str += "</table>";
    $("#shape-table").html(str);

    document.getElementById("shape-dialog-copywrite-info").innerHTML = "";

    $('#shape-table tr').click(function (event) {
        var myClass = $(this).attr("class"),
            index = myClass.split(/wsShape_/)[1];
        $('#modal-shape-selector-dialog').trigger( "european-steel-shape-selected", currentShapesArray[index]);
        $(function () {
            $('#modal-shape-selector-dialog').modal('toggle');
        });
    });
}

function loadCustomAluminumShapesTable() {

    document.getElementById('use-custom-shape-checkbox').classList.add('hidden');

    let data = customAluminumShapes;

    if (data.length <= 0) {
        return;
    }

    document.getElementById('ply-selector-group').classList.add('hidden');

    currentShapesArray = data;

    var str = '';

    str = "<table class='table'><thead>";
    str += "<tr>";
    str += "<th>Name</th>";
    str += "<th>Area</th>";
    str += "<th>Weight (lb/ft)</th>";
    str += "<th>Ix (in<sup>4</sup>)</th>";
    str += "<th>Sx (in<sup>3</sup>)</th></tr>";
    str += "</thead>";

    for(var i = 0; i < data.length; i++) {
        str += "<tr class='wsShape_" + i + "'>";
        str += "<td>" + data[i]['Name'] + "</td>";
        str += "<td>" + data[i].A + "</td>";
        str += "<td>" + Number(data[i].W).toFixed(2) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Ix).toFixed(3).toString()) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Sx).toFixed(3).toString()) + "</td>";
    }
    str += "</table>";
    $("#shape-table").html(str);

    document.getElementById("shape-dialog-copywrite-info").innerHTML = "";

    $('#shape-table tr').click(function (event) {
        var myClass = $(this).attr("class"),
            index = myClass.split(/wsShape_/)[1];
        const customEvent = new CustomEvent('custom-aluminum-shape-selected', { detail: currentShapesArray[index] })
        document.dispatchEvent(customEvent)
        $('#modal-shape-selector-dialog').modal('toggle');
        //$(function () {
        //    $('#modal-shape-selector-dialog').modal('toggle');
        //});
    });
}

function loadCustomSoldierShapesTable() {

    document.getElementById('use-custom-shape-checkbox').classList.add('hidden');

    let data = customSoldierShapes;

    if (data.length <= 0) {
        return;
    }

    document.getElementById('ply-selector-group').classList.add('hidden');

    currentShapesArray = data;

    var str = '';

    str = "<table class='table'><thead>";
    str += "<tr>";
    str += "<th>Name</th>";
    str += "<th>Area</th>";
    str += "<th>Weight (lb/ft)</th>";
    str += "<th>Ix (in<sup>4</sup>)</th>";
    str += "<th>Sx (in<sup>3</sup>)</th></tr>";
    str += "</thead>";

    for(var i = 0; i < data.length; i++) {
        str += "<tr class='wsShape_" + i + "'>";
        str += "<td>" + data[i]['Name'] + "</td>";
        str += "<td>" + data[i].A + "</td>";
        str += "<td>" + Number(data[i].W).toFixed(2) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Ix).toFixed(3).toString()) + "</td>";
        str += "<td>" + parseFloat(Number(data[i].Sx).toFixed(3).toString()) + "</td>";
    }
    str += "</table>";
    $("#shape-table").html(str);

    document.getElementById("shape-dialog-copywrite-info").innerHTML = "";

    $('#shape-table tr').click(function (event) {
        var myClass = $(this).attr("class"),
            index = myClass.split(/wsShape_/)[1];
        $('#modal-shape-selector-dialog').trigger( "custom-soldier-shape-selected", currentShapesArray[index]);
        $(function () {
            $('#modal-shape-selector-dialog').modal('toggle');
        });
    });
}

function getNorthAmericanSteelShapes(filename) {
    if (!(filename in shapeLoaderCache)) {
        $.get("shape-data/" + filename, function (data) {
            shapeLoaderCache[filename] = data;
            loadNorthAmericanSteelShapesTable(data);
        });
    } else {
        loadNorthAmericanSteelShapesTable(shapeLoaderCache[filename]);
    }
}

function getEuropeanSteelShapes(filename) {
    if (!(filename in shapeLoaderCache)) {
        $.get("shape-data/" + filename, function (data) {
            shapeLoaderCache[filename] = data;
            loadEuropeanSteelShapesTable(data);
        });
    } else {
        loadEuropeanSteelShapesTable(shapeLoaderCache[filename]);
    }
}

function getWoodShapes(filename) {
    if (!(filename in shapeLoaderCache)) {
        $.get("shape-data/" + filename, function (data) {
            shapeLoaderCache[filename] = data;
            loadWoodShapesTable(data);
        });
    } else {
        loadWoodShapesTable(shapeLoaderCache[filename]);
    }
}

function getEngineeredLumberShapes(filename) {
    if (!(filename in shapeLoaderCache)) {
        $.get("shape-data/" + filename, function (data) {
            shapeLoaderCache[filename] = data;
            loadEngineeredLumberShapesTable(data);
        });
    } else {
        loadEngineeredLumberShapesTable(shapeLoaderCache[filename]);
    }
}

function getTrusJoistShapes() {
    var filename = 'engineered-lumber/trus-joist-shapes.json';
    if (!(filename in shapeLoaderCache)) {
        $.get("shape-data/" + filename, function (data) {
            shapeLoaderCache[filename] = data;
            loadEngineeredLumberShapesTable(data);
        });
    } else {
        loadEngineeredLumberShapesTable(shapeLoaderCache[filename]);
    }
}
